import { UserResponseDto } from "../shared/dtos/user/UserResponseDto";
import { UserSummaryDto } from "../shared/dtos/user/UserSummaryDto";

export class UserMapper {
  public static mapUserToSummary = (
    detailedUser: UserResponseDto,
  ): UserSummaryDto => {
    return {
      id: detailedUser.id,
      firstName: detailedUser.firstName,
      lastName: detailedUser.lastName,
      username: detailedUser.username,
      email: detailedUser.email,
      status: detailedUser.status,
      enabled: detailedUser.enabled,
      locked: detailedUser.locked,
      userRole: detailedUser.userRole,
      branchId: detailedUser.branchId,
      createdAt: detailedUser.createdAt,
      updatedAt: detailedUser.createdAt,
    };
  };
}
